"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PEPRelatedAccessoriesResponse = exports.PEPProductDetailsResponse = exports.PEPBrowseHearingAidsResponse = exports.PEPBrowseAccessoriesResponse = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable max-classes-per-file */

/**
 * @class
 */
var PEPBrowseAccessoriesResponse = function PEPBrowseAccessoriesResponse() {
  _classCallCheck(this, PEPBrowseAccessoriesResponse);

  /**
   * @type {object}
   * @property {string} name
   * @property {string} descriptionConsumer
   */
  this.brand = undefined;
  /**
   * @type {PEPProduct[]}
   */

  this.accessories = undefined;
};
/**
 * @class
 */


exports.PEPBrowseAccessoriesResponse = PEPBrowseAccessoriesResponse;

var PEPBrowseHearingAidsResponse = function PEPBrowseHearingAidsResponse() {
  _classCallCheck(this, PEPBrowseHearingAidsResponse);

  /**
   * @type {object}
   * @property {string} name
   * @property {string} descriptionConsumer
   */
  this.brand = undefined;
  /**
   * @type {PEPProductDetail[]}
   */

  this.hearingaids = undefined;
};
/**
 * @class
 */


exports.PEPBrowseHearingAidsResponse = PEPBrowseHearingAidsResponse;

var PEPProductDetailsResponse = function PEPProductDetailsResponse() {
  _classCallCheck(this, PEPProductDetailsResponse);

  /**
   * @type {PEPProductDetail[]}
   */
  this.products = undefined;
};
/**
 * @class
 */


exports.PEPProductDetailsResponse = PEPProductDetailsResponse;

var PEPRelatedAccessoriesResponse = function PEPRelatedAccessoriesResponse() {
  _classCallCheck(this, PEPRelatedAccessoriesResponse);

  /**
   * @type {PEPProduct[]}
   */
  this.relatedAccessories = undefined;
};
/**
 * @typedef PEPProduct
 * @type {object}
 * @property {number} productId
 * @property {string} title
 * @property {string} subtitle
 * @property {string} description
 * @property {string} shortDescription
 * @property {string} descriptionConsumer
 * @property {string} productBrand
 * @property {string} productFamily
 * @property {string} productModel
 * @property {string} productStyle
 * @property {string} pepReleaseDate
 * @property {string} designedFor
 * @property {boolean} telecoil
 * @property {boolean} rechargeability
 * @property {boolean} bluetooth
 * @property {string[]} hearingLossSeverity
 * @property {string[]} batterySizes
 * @property {number[]} expectedBatteryLife
 * @property {PEPResource[]} images
 * @property {PEPResource[]} marketingMaterials
 * @property {PEPApp[]} apps
 * @property {PEPAdditionalInformation[]} additionalInformation
 * @property {PEPBenefit[]} benefits
 */

/**
 * @typedef PEPProductDetail
 * @extends PEPProduct
 * @property {string} iosVersion
 * @property {string} androidVersion
 * @property {string} styleCategory
 * @property {string} bluetoothExcludesTelecoil
 * @property {string} bteOrIte
 * @property {PEPProductItem[]} items
 */

/**
 * @typedef PEPResource
 * @type {object}
 * @property {string} fileName
 * @property {string} imageUrl
 * @property {string} marketingMaterialType
 * @property {string} launchTag
 * @property {string[]} languages
 */

/**
 * @typedef PEPApp
 * @type {object}
 * @property {string} title
 * @property {object} information
 * @property {PEPResource[]} images
 * @property {PEPBenefit[]} oticonBenefits
 */

/**
 * @typedef PEPAdditionalInformation
 * @type {object}
 * @property {string} title
 * @property {PEPResource[]} marketingMaterials
 */

/**
 * @typedef PEPBenefit
 * @type {object}
 * @property {string} title
 * @property {string} descriptionConsumer
 * @property {string} category
 */

/**
 * @typedef PEPProductItem
 * @type {object}
 * @property {number} itemId
 * @property {string} description
 * @property {string} colorName
 * @property {string} colorCode
 * @property {string} colorRGB
 * @property {string} secondaryColorName
 * @property {string} secondaryColorCode
 * @property {string} secondaryColorRGB
 * @property {string} fittingLevel
 * @property {string} itemNumber
 * @property {number} relatedProductId
 * @property {PEPResource[]} images
 * @property {PEPResource[]} marketingMaterials
 */


exports.PEPRelatedAccessoriesResponse = PEPRelatedAccessoriesResponse;